// @greenlight-spec: 15-database-schema.md
// @greenlight-spec: 16-api-conventions.md
// One feedback channel, two sources. `source` is the ADR-0029 operator axis,
// derived server-side from the submission channel (agent surface → 'agent',
// dashboard → 'user') and never client-claimed; `surface` records the concrete
// entry point. The principal behind every submission is the submitting user.
export const FEEDBACK_SOURCES = ['agent', 'user'];
export const FEEDBACK_SURFACES = ['mcp', 'cli', 'dashboard'];
export const FEEDBACK_CATEGORIES = ['bug', 'friction', 'suggestion', 'other'];
// `sent` is the default post-share triage state. The durable hand-off record is
// `sent_at` (docs/15); the inbox sinks any row that has one (docs/28 §/feedback).
export const FEEDBACK_STATUSES = ['unread', 'read', 'archived', 'sent'];
/**
 * Statuses an org-admin may set by hand. `sent` is excluded on purpose: it is
 * written only by the share path, together with `sent_at`. Marking an item
 * `sent` by hand would claim Shift has something it does not.
 */
export const FEEDBACK_TRIAGE_STATUSES = ['unread', 'read', 'archived'];
/**
 * Who wrote an agent report. Absent means the in-loop agent did; `observer` means
 * the plugin's observer hook did. Self-reported triage metadata for the badge and
 * the grouping, never proof of origin: an in-loop agent can set it too.
 */
export const FEEDBACK_ORIGINS = ['observer'];
/** A report fingerprint: lowercase hex of a hash over the verb and error codes. */
export const FEEDBACK_FINGERPRINT_PATTERN = /^[0-9a-f]{16,64}$/;
// Size + count caps enforced at every submission boundary (T-986 AC-FEEDBACK-03).
// Body ≤32 KiB keeps an untrusted payload bounded; the id caps bound the
// allowlisted request-id list and the bulk-status mutation.
export const FEEDBACK_CAPS = {
    titleMaxChars: 200,
    bodyMaxChars: 32_768,
    maxRequestIds: 20,
    maxBulkIds: 100,
};
//# sourceMappingURL=feedback.js.map